import { DocumentSigningOrder } from 'src/app/modules/loan-docs/models/document-signing-order.model';

export const shouldRedactEnvelopeId = (isTpoUser: boolean, settingEnabled: boolean): boolean =>
  isTpoUser && settingEnabled;

export const getEsignatureDescription = (order: DocumentSigningOrder): string | null => {
  const description = order.loanDocTasks
    ?.map(task => task.description?.trim())
    .find(value => !!value);

  return description || null;
};
